import { createStore } from 'vuex';

import globalConfig from 'shared/store/globalConfig';
import accounts from './modules/accounts';
import agents from './modules/agents';
import attributes from './modules/attributes';
import auth from './modules/auth';
import bulkActions from './modules/bulkActions';
import bulkEmailActions from './modules/bulkEmailActions';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contacts from './modules/contacts';
import contentPanel from './modules/contentPanel';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import draftMessages from './modules/draftMessages';
import editor from './modules/editor';
import engineerThreads from './modules/engineerThreads';
import hotels from './modules/hotels';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import labels from './modules/labels';
import notifications from './modules/notifications.js';
import rightSidebar from './modules/rightSidebar';
import sharedState from './modules/sharedState';

const plugins = [];

export default createStore({
  modules: {
    accounts,
    agents,
    attributes,
    auth,
    bulkActions,
    bulkEmailActions,
    contactConversations,
    contactLabels,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    globalConfig,
    hotels,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    labels,
    notifications,
    rightSidebar,
    draftMessages,
    sharedState,
    editor,
    contentPanel,
    engineerThreads,
  },
  plugins,
});
